export const THEME_SET_USER_DATA = 'POST_FETCH_DATA';

export const setUserInfo = userInfo => async dispatch => {
    dispatch({type: THEME_SET_USER_DATA, payload: userInfo});
};

